import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {CoachService} from '../modules/coach/service/coach.service';
import {CoachSessionModel} from '../modules/coach/models/session.model';


@Injectable({ providedIn: 'root' })
export class CoachingSessionResolver implements Resolve<CoachSessionModel> {
    constructor(private coachService: CoachService) {}

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<CoachSessionModel> {
        return this.coachService.getCoachSessionInfo(route.paramMap.get('sessionId'));
    }
}
